<template>
    <div class="ts-widget-small" v-if="dataLoaded && data.feedbacks.length > 0">
        <div class="rate">
            <div class="a">
                <span class="blank">
                    <i class="fa fa-star"></i>
                    <i class="fa fa-star"></i>
                    <i class="fa fa-star"></i>
                    <i class="fa fa-star"></i>
                    <i class="fa fa-star"></i>
                </span>
                <span class="full" :style="'width:' + parseFloat(data.fb_avg) * 20 + '%'">
                    <i class="fa fa-star"></i>
                    <i class="fa fa-star"></i>
                    <i class="fa fa-star"></i>
                    <i class="fa fa-star"></i>
                    <i class="fa fa-star"></i>
                </span>
            </div>
            <div class="b">({{ data.fb_count_total }} {{ $attrs.text }})</div>
        </div>

        <component is="style">

        </component>
    </div>
</template>

<script>
    export default {
        data: function() {
            return {
                data:[],
                dataLoaded: false
            }
        },
        mounted() {
            var self = this,
            data = [];

            $.getJSON('https://teppichversand24.net/cyt/ekomi/fb/fbget?id=' + this.$attrs.itemId + '&lang=' + this.$attrs.lang + '&limit=100').done(function( data ) {
                self.data = data;
                self.dataLoaded = true;
            })
        }
    }
</script>
